export const SOFTLINE_API_MDE_RETOUREN_BEWEGUNGEN = '/v1/retouren/bewegung/entities'
export const SOFTLINE_API_MDE_RETOUREN_ABSCHLUSS = '/v1/retouren/abschluss'
export const SOFTLINE_API_MDE_RETOUREN_ARTIKEL = '/v1/retouren/artikel/entities'
export const SOFTLINE_API_MDE_RETOUREN_KOPF = '/v1/retouren'
export const SOFTLINE_API_MDE_RETOUREN_LAGERPLATZ_SCAN = '/v1/lagerplatz/scan/{{code}}'
